import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function ccr1(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@ccr1/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@ccr1/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@ccr1/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@ccr1/UPDATE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@ccr1/UPDATE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@ccr1/UPDATE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}